import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useNavigateAndScroll } from '../../Hooks/useNavigateAndScroll';

const ImagesRow = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const navigateAndScroll = useNavigateAndScroll();
  const handleNavigateAndScroll = (pathname, sectionId) => {
    if (location.pathname !== pathname) {
      navigate(pathname);
    }

    setTimeout(() => {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }, 100); // Adjust the timeout as needed to ensure the page has navigated
  };

  const images = [
    {
      src: 'https://cipa-website-assets.s3.us-east-2.amazonaws.com/site-photos/Expecting+Parents.webp',
      text: 'Expecting Parents',
      navigation: () => navigateAndScroll('/services/expectant-parents'),
    },
    {
      src: 'https://cipa-website-assets.s3.us-east-2.amazonaws.com/site-photos/Make+Appointment.webp',
      text: 'Healow Check-in',
      navigation: () => handleNavigateAndScroll('/checkIn', ''),
    },
    {
      src: 'https://cipa-website-assets.s3.us-east-2.amazonaws.com/site-photos/New+Patients.webp',
      text: 'New Patients',
      navigation: () => navigateAndScroll('/patient-center/new-patient'),
    },
    {
      src: 'https://cipa-website-assets.s3.us-east-2.amazonaws.com/site-photos/Patient+Portal.webp',
      text: 'Patient Portal',
      // Opens the portal in a new tab instead of navigating within the app
      navigation: () =>
        window.open(
          'https://mycw65.ecwcloud.com/portal8399/jsp/100mp/login_otp.jsp',
          '_blank',
          'noopener,noreferrer'
        ),
    },
  ];

  return (
    <div className="flex flex-wrap justify-around mb-2 mx-2 rounded-lg">
      {images.map((image, index) => (
        <div key={index} className="relative flex-1 m-1 shadow-xl">
          <img
            src={image.src}
            alt={image.text}
            className="w-full h-full object-cover rounded-lg smartphone:hidden"
          />
          <div className="absolute bottom-0 left-0 right-0 mb-3 flex justify-center items-center smartphone:relative smartphone:mb-0">
            <button
              className="text-white font-bold bg-custom-regularOrange hover:bg-custom-darkOrange rounded-lg px-4 py-2 text-lg transform scale-110 max-w-full max-h-full smartphone:w-full smartphone:h-full smartphone:text-sm smartphone:rounded-lg tablet:text-md tablet:scale-110"
              onClick={image.navigation}
              style={{
                maxWidth: '90%',
                maxHeight: '90%',
                width: 'auto',
                height: 'auto',
              }}
            >
              {image.text}
            </button>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ImagesRow;
